var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5837 68.6832C70.9409 68.6832 68.7985 66.5408 68.7985 63.898V36.0338C68.7985 26.6426 61.1581 19.002 51.7667 19.002C42.3755 19.002 34.7349 26.6424 34.7349 36.0338V52.2402C34.7349 54.883 32.5925 57.0254 29.9497 57.0254C27.3069 57.0254 25.1646 54.883 25.1646 52.2402V36.0338C25.1646 21.3652 37.0981 9.43164 51.7667 9.43164C66.4352 9.43164 78.3689 21.3652 78.3689 36.0338V63.898C78.3689 66.5408 76.2265 68.6832 73.5837 68.6832Z",
    fill: "#B1B4B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8819 97.6598H22.6519C17.2153 97.6598 12.8081 93.2525 12.8081 87.816V54.1504C12.8081 48.7139 17.2153 44.3066 22.6519 44.3066H80.8819C86.3185 44.3066 90.7257 48.7139 90.7257 54.1504V87.8158C90.7257 93.2525 86.3185 97.6598 80.8819 97.6598Z",
    fill: "#0D216D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3499 89.727H20.8567C19.3034 89.727 18.0442 88.4678 18.0442 86.9145V55.0527C18.0442 53.4994 19.3034 52.2402 20.8567 52.2402H21.3499C22.9032 52.2402 24.1624 53.4994 24.1624 55.0527V86.9145C24.1624 88.4678 22.9032 89.727 21.3499 89.727Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionLock);
export default __webpack_public_path__ + "static/media/subscription-lock.78077f37c08ce5d643c6a59144b04a49.svg";
export { ForwardRef as ReactComponent };